import Cookies from "js-cookie";
import { csrfFetch } from "./csrf.js";
import { gcoreServerUrl } from '../config.js';

// IF-GFILE-001, 파일 업로드
export const sendFile = async (formData) => {
  const options = {
    method: 'POST',
    // headers: { 'Content-Type': 'multipart/form-data' },
    body: formData,
  }

  options.headers = {};
  options.headers["XSRF-Token"] = Cookies.get("XSRF-TOKEN");
  const accessToken = sessionStorage.getItem('accessToken');
  if (accessToken) {
    options.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const response = await window.fetch(`${gcoreServerUrl}/api/gfiles`, options);
  
  const data = await response.json();
  return data;
};

// IF-GFILE-002, 파일 삭제
export const removeFile = async ({ seq, refType }) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gfiles/seq/${seq}/refType/${refType}`, {
    method: "DELETE",
  });
  return response;
};

// IF-GFILE-003, 파일 다운로드 (로그인권한)
export const download = async (seq, refType) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gfiles/seq/${seq}/refType/${refType}`);
  return response;
};

// IF-GFILE-004, 파일 다운로드 (비로그인권한)
export const downloadFile = async (seq, refType) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gfiles/downloadFile/seq/${seq}/refType/${refType}`);
  return response;
};

// 파일 URL 조회
export const getFileUrl = async (seq, refType) => {
  const url = `${gcoreServerUrl}/api/gfiles/downloadFile/seq/${seq}/refType/${refType}`;
  return url;
};

// IF-GFILE-005, 파일 목록
export const selectAll = async (params) => {
  // URL에 쿼리 파라미터 추가
  const searchParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach(key => {
      searchParams.append(key, params[key]);
    });
  }

  const queryString = searchParams.toString();
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gfiles?${queryString}`);

  const data = await response.json();
  return data.gfiles;
};

const initialState = {
};

function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

export default reducer;
